(function () {
  function init() {
    var mobile = document.getElementById('MobileNav');
    if (!mobile || mobile.dataset.a1Ready) return;
    mobile.dataset.a1Ready = 'true';
    mobile.querySelectorAll('li').forEach(function (li, index) {
      var link = li.querySelector(':scope > a, :scope > .a1-mobile-heading');
      var list = li.querySelector(':scope > ul');
      if (!link || !list) return;
      var label = link.textContent.trim();
      var row = document.createElement('div');
      row.className = 'a1-nav-row';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'a1-nav-toggle';
      button.innerHTML = '<i class="at at-plus-l" aria-hidden="true"></i>';
      list.id = 'a1-nav-group-' + index;
      button.setAttribute('aria-label', 'Expand ' + label);
      button.setAttribute('aria-controls', list.id);
      button.setAttribute('aria-expanded', 'false');
      link.querySelectorAll('.at-plus-l, .at-minus-l').forEach(function (icon) { icon.remove(); });
      li.insertBefore(row, link);
      row.appendChild(link);
      row.appendChild(button);
      list.style.display = 'none';
      button.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', (open ? 'Collapse ' : 'Expand ') + label);
        list.style.display = open ? 'block' : 'none';
        var icon = button.querySelector('.at');
        if (icon) { icon.classList.toggle('at-plus-l', !open); icon.classList.toggle('at-minus-l', open); }
      });
    });
    document.querySelectorAll('#siteNav a, #MobileNav a').forEach(function (link) {
      if (link.textContent.trim() !== 'Find Your Tartan') return;
      link.addEventListener('click', function (e) {
        var trigger = document.querySelector('[data-a1-tm-open]'); if (!trigger) return;
        e.preventDefault();
        var close = document.querySelector('.mobile-nav-wrapper.active .closemmn'); if (close) close.click();
        trigger.click();
      });
    });
    document.querySelectorAll('#siteNav > li.parent').forEach(function (li) {
      var trigger = li.querySelector(':scope > a');
      if (!trigger) return;
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      li.addEventListener('keydown', function(e) {
        if(e.key === 'Escape') {
          trigger.focus(); li.classList.add('a1-nav-dismissed'); trigger.setAttribute('aria-expanded', 'false');
        }
      });
      li.addEventListener('focusin', function() { trigger.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('focusout', function(e) {
        if (!li.contains(e.relatedTarget)) { li.classList.remove('a1-nav-dismissed'); trigger.setAttribute('aria-expanded', 'false'); }
      });
      li.addEventListener('mouseenter', function() { li.classList.remove('a1-nav-dismissed'); trigger.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function() { trigger.setAttribute('aria-expanded', 'false'); });
    });
  }
  // Clan letters are one or three characters long: give screen readers the full meaning.
  function labelLetters() {
    document.querySelectorAll('#siteNav a[href$="/collections/tartans-clan"], #MobileNav a[href$="/collections/tartans-clan"]').forEach(function (head) {
      var li = head.closest('li'); if (!li) return;
      li.querySelectorAll('ul a').forEach(function (a) {
        var t = a.textContent.trim();
        if (/^[A-Z]$|^Mac$|^Mc$|^M$/.test(t) || /^M[ -]/.test(t)) a.setAttribute('aria-label', 'Clans and families: ' + t);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', labelLetters); labelLetters();
  // Keep every open panel inside the window (the menu places it under its own item, which can run past the edge on 1280px screens).
  function clampPanels() {
    document.querySelectorAll('#siteNav > li.lvl1').forEach(function (li) {
      var panel = li.querySelector(':scope > .megamenu, :scope > ul, :scope > div'); if (!panel || li.a1Clamp) return; li.a1Clamp = true;
      function place() {
        // Work from the panel's own position (without our shift), and never clear the shift first: clearing it made the panel slide back to the left edge on every hover and click.
        requestAnimationFrame(function () {
          var r = panel.getBoundingClientRect(); if (!r.width) return;
          var cur = parseFloat(panel.style.translate) || 0, m = 16, w = r.width, natural = r.left - cur;
          var left = Math.max(m, Math.min(li.getBoundingClientRect().left - 18, window.innerWidth - m - w));
          var dx = Math.round(left - natural);
          if (dx !== cur) panel.style.translate = dx + 'px 0';
        });
      }
      li.addEventListener('mouseenter', place); li.addEventListener('focusin', place);
    });
  }
  document.addEventListener('DOMContentLoaded', clampPanels); clampPanels();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
